import Vue from 'vue'
import Router from 'vue-router'
import Map from './map'
import Nurse from './nurse'
import Business from './business'
import Online from './online'
import MedicalRecord from './medicalRecord'
import CloudClinic from './cloudClinic'

Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/demo'
    },
    {
      path: '/demo',
      component: () => import('../pages/demo')
    },
    {
      path: '/article/:id',
      component: () => import('../pages/article')
    },
    // http://wx.hztywl.cn/bzb/h5.
    // html?#/download
    // http://localhost:8080/h5.html?#/download
    {
      name: 'download',
      path: '/download',
      component: () => import('../pages/download-app')
    },
    {
      name: 'download_doc',
      path: '/download_doc',
      component: () => import('../pages/download-doc-app')
    },
    {
      path: '/pay',
      meta: {
        title: '支付'
      },
      component: () => import('../pages/pay')
    },
    // http://wx.hztywl.cn/bzb/h5.html#/pay?appid=wxa49f90b4ff678ef2&sign=7A58145D95017D9B73E8CC47728EF18D&prepayid=wx05161143145498b56ff389010110466402&nonceStr=2ig8RB74xuAt18Br&timestamp=1557043763
    {
      path: '/pay/succeed',
      meta: {
        title: '支付'
      },
      component: () => import('../pages/pay-succeed')
    },
    /**
     * 隐私协议
     */
    {
      path: '/ios/privacy',
      meta: {
        title: '隐私协议'
      },
      component: () => import('../pages/paper/privacy')
    },
    ...Map,
    ...Nurse,
    ...Business,
    ...Online,
    ...MedicalRecord,
    ...CloudClinic
  ]
})



// WEBPACK FOOTER //
// ./h5/router/index.js